// extracted by mini-css-extract-plugin
export default {"noticeWrap":"notice_noticeWrap__10kGg","noticeList":"notice_noticeList__l2o8O","select":"notice_select__jLlqx","title":"notice_title__wsA5F","content":"notice_content__C6OTj"};